<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div class="formTableItem" style="margin-left:15px">
        <Button @click="openAdd" type="primary">新增流程</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <liucheng-tool ref="liuchengTool" @item="addUpdate"></liucheng-tool>
  </div>
</template>
<script>
import liuchengTool from "./liuchengTool.vue";
export default {
  components: { liuchengTool },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "流程名称",
          key: "name",
        },
        {
          title: "所属单位",
          key: "groupName",
        },
        {
          title: "备注信息",
          key: "content",
        },
        {
          title: "创建者账号",
          key: "status1",
        },
        {
          title: "版本号",
          key: "ver",
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        icon: "car",
        remark: "",
        category: "其他类",
        serverUrl:'https://cloud.ly-gps.com/cloud-car-server-dpc/apply'
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/list",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].status = String(data[i].status);
          data[i].status1 = this.$t("flowStatus." + data[i].status);
          
        }
        this.tableData = data;
      });
    },
    addUpdate(v) {
      this.item = v;
      this.utils.loading(this, "保存中");
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.flow + "/flowConfig/add",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.openForm = false;
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.flow + "/flowConfig/update",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.openForm = false;
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.flow + "/flowConfig/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.$refs.liuchengTool.open(this.isAdd, row);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.liuchengTool.open(this.isAdd);
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/diaodu/liucheng.vue